/* unplugin-vue-components disabled */import { render } from "./SdkInfo.vue?vue&type=template&id=515f4784&scoped=true"
import script from "./SdkInfo.vue?vue&type=script&lang=js"
export * from "./SdkInfo.vue?vue&type=script&lang=js"

import "./SdkInfo.vue?vue&type=style&index=0&id=515f4784&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515f4784"]])

export default __exports__